import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { EmailField } from '@shared/data/entity/fields/EmailField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: EmailField;
  style: StyleProp<ViewStyle>;
}

const emailStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

const MAX_EMAILS_TO_SHOW = 2;

export function EmailCollectionViewField({ field, style }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const emailsToShow = field.emails.slice(0, MAX_EMAILS_TO_SHOW);
  const remainingEmailCount = field.emails.length - MAX_EMAILS_TO_SHOW;

  return (
    <CardCollectionViewFieldContainer style={[emailStyles, style]}>
      <View>
        {emailsToShow.map((email: string) => (
          <View key={email}>
            <Text size="body1" numberOfLines={1}>
              {email}
            </Text>
          </View>
        ))}
        {remainingEmailCount > 0 && (
          <View>
            <Text size="body1" numberOfLines={1}>
              +{remainingEmailCount} more
            </Text>
          </View>
        )}
      </View>
    </CardCollectionViewFieldContainer>
  );
}
